import Model from 'flarum/common/Model';
export default class SocialGroup extends Model {
  name() {
    return this.attribute('name');
  }
  slug() {
    return this.attribute('slug');
  }
  description() {
    return this.attribute('description');
  }
  color() {
    return this.attribute('color');
  }
  imageUrl() {
    return this.attribute('imageUrl');
  }
  bannerUrl() {
    return this.attribute('bannerUrl');
  }
  isPrivate() {
    return this.attribute('isPrivate');
  }
  memberCount() {
    return this.attribute('memberCount');
  }

  /** The set name ("Houses") this group shares with others: one membership between them. */
  exclusiveSet() {
    return this.attribute('exclusiveSet');
  }

  /** {id, name} of the actor's group in the same set, which joining this one would leave. */
  exclusiveWith() {
    return this.attribute('exclusiveWith');
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }
  canEdit() {
    return this.attribute('canEdit');
  }
  isMember() {
    return this.attribute('isMember');
  }
  actorIsMuted() {
    return this.attribute('actorIsMuted');
  }
  isCreator() {
    return this.attribute('isCreator');
  }
  membershipType() {
    return this.attribute('membershipType') || 'open';
  }
  ownedThroughKiosk() {
    return this.attribute('ownedThroughKiosk') || false;
  }
  isFeatured() {
    return this.attribute('isFeatured') || false;
  }
  canFeature() {
    return this.attribute('canFeature') || false;
  }
  isPending() {
    return this.attribute('isPending') || false;
  }
  pendingRequestCount() {
    return this.attribute('pendingRequestCount') || 0;
  }
  user() {
    return Model.hasOne('user').call(this);
  }
}
flarum.reg.add('ernestdefoe-social-groups', 'forum/models/SocialGroup', SocialGroup);